export default __webpack_public_path__ + "static/media/img-mwa-user-experience-01.08319bfe.png";